import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../../atoms'

type LocationPickerMobileFooterProps = {
  onClick: () => void
  disabled: boolean
}

export const LocationPickerMobileFooter: React.FC<
  LocationPickerMobileFooterProps
> = ({ onClick, disabled }) => {
  return (
    <div className='flex justify-end border-t border-t-border bg-background px-[5vw] py-[10px]'>
      <Button onClick={onClick} className='px-5 py-[10px]' disabled={disabled}>
        <FormattedMessage
          id='ui.BudgetPicker.save'
          defaultMessage='Enregistrer'
        />
      </Button>
    </div>
  )
}
